import { FollowUpElementDialogComponent } from './portfolio-table/followup-element-dialog/followup-element-dialog.component';
import { DeleteElementDialogComponent } from './portfolio-table/delete-element-dialog/delete-element-dialog.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { MatIconModule } from '@angular/material/icon';
import { ChartModule } from './chart/chart.module';
import { ToCartesianPipe } from './to-cartesian.pipe';
import { EntityManagerModule } from '../entity-manager/entity-manager.module';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatChipsModule } from '@angular/material/chips';
import { ChartClComponent } from './chart-cl/chart-cl.component';
import { ChartsAllIndClComponent } from './charts-all-ind-cl/charts-all-ind-cl.component';

@NgModule({
  declarations: [
    BarChartComponent,
    ToCartesianPipe,
    DeleteElementDialogComponent,
    FollowUpElementDialogComponent,
    ChartClComponent,
    ChartsAllIndClComponent,
  ],
  exports: [
    BarChartComponent,
    ChartModule,
    DeleteElementDialogComponent,
    FollowUpElementDialogComponent,
    ChartClComponent,
    ChartsAllIndClComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    ChartModule,
    EntityManagerModule,
    MatDialogModule,
    MatChipsModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    FormsModule,
    MatSnackBarModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class DataDisplayerModule {}
